import * as React from "react";

export function useWindowEventListener<K extends keyof WindowEventMap>(
    eventName: K,
    handler: (ev: WindowEventMap[K]) => void
): void {
    const handlerRef = React.useRef<(ev: WindowEventMap[K]) => void>();

    React.useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    React.useEffect(() => {
        const eventListener = (ev: WindowEventMap[K]) => handlerRef.current?.(ev);
        window.addEventListener(eventName, eventListener);
        return () => {
            window.removeEventListener(eventName, eventListener);
        };
    }, [eventName]);
}

export const useBeforeunload = (condition: boolean, message: string) =>
    useWindowEventListener("beforeunload", (event: Event): string | undefined => {
        if (condition) {
            event.preventDefault();

            // Gecko, Trident, Chrome 34+
            event.returnValue = true;

            // Gecko, WebKit, Chrome <34
            return message;
        }

        return undefined;
    });
